import {DiscoverReqCtx} from './getScout';

interface CastMember {
  memberName: string,
  memberImage: string,
  CastAndCrewTitleList: CastAndCrewTitle[],
  memberId?:string
}

interface CastAndCrewTitle {
  titleName: string,
  titleImage: string,
  titleImagePackshot: string,
  titleId: string,
  titleIsPrime: boolean,
  titleIsValid?: boolean,
  titleType: string,
  titleRating?: string,
  titleRatingCount?: string,
  titleCatalogName: string
}

export namespace GetCastAndCrew {
    export interface ServersideRequest extends DiscoverReqCtx {
      titleId: string,
    };
    
    export interface Response {
      CastMemberList: CastMember[],
  };
};
